import React, { Component, Fragment } from 'react';
import { Button, Modal, Tag, Input, message, Divider, DatePicker, Row } from 'antd';
import { Menu } from '../../../../services/api';

export default class CreateMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            modalVisible: false,
            title: '',
            weeks: [],
            customer: this.props.customer,
            allocatedWeeks: this.props.allocatedWeeks
        }

        this.menuApi = new Menu(props);
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.allocatedWeeks.length !== nextProps.allocatedWeeks) {
            this.setState({ allocatedWeeks: nextProps.allocatedWeeks });
        }
    }

    componentWillUnmount() {
        this.isCancelled = true;
    }

    showAddModal = () => {
        this.setState({ modalVisible: true });
    }

    handleCancel = () => {
        this.setState({ modalVisible: false, weeks: [], title: '' });
    }

    createMenu = () => {
        const { title } = this.state;
        if (title === '') {
            message.error('Ange ett namn för menyn.');
            return;
        }

        const data = {
            title: title,
        };

        this.setState({ loading: true });
        this.menuApi.create(data)
            .then(res => {
                this.createCustomerMenu(res.data.data);
            })
            .catch(_ => {
                this.menuApi.retry({ cb: this.createMenu });
            });
    }
    
    createCustomerMenu = (menu) => {
        const { customer } = this.props;
        const { weeks } = this.state;

        const data = {
            origin_id: menu.id,
            weeks: weeks,
            custom: true
        };

        this.menuApi.raw().post(customer._links['add-menu'].href, data)
            .then(res => {
                this.setState({ loading: false, modalVisible: false, title: '', weeks: [] });
                res.data.data.origin = menu;
                this.props.onSuccess(res.data.data);
            })
            .catch(_ => {
                this.menuApi.retry({ params: [menu], cb: this.createCustomerMenu });
            });
    }

    onWeekChange = (date) => {
        if (!date) {
            return;
        }

        const { weeks } = this.state;
        const week = date.isoWeek();

        const allocatedWeeks = weeks.concat(this.state.allocatedWeeks);
        const index = allocatedWeeks.findIndex(w => w === week);
        if (index !== -1) {
            message.error(`Det finns redan en meny sparad för vecka: ${week}`);
            return;
        }

        weeks.push(week);
        this.setState({ weeks });
    }

    removeWeek = (week) => {
        const { weeks } = this.state;
        const index = weeks.findIndex(w => w === parseInt(week, 10));
        if (index !== -1) {
            weeks.splice(index, 1);
            this.setState({ weeks });
        }
    }

    render() {
        const { loading, modalVisible, title, weeks } = this.state;

        return (
            <Fragment>
                <Button style={this.props.style} type="primary" icon="plus" onClick={this.showAddModal}>
                    Skapa ny meny
                </Button>

                <Modal
                    title="Skapa ny meny"
                    visible={modalVisible}
                    okText="Spara"
                    cancelText="Avbryt"
                    onOk={this.createMenu}
                    onCancel={this.handleCancel}
                    okButtonProps={{ loading: loading }}
                >
                    <Row type="flex" justify="center">
                        <Divider style={{ marginTop: 0 }}>1. Välj namn</Divider>
                        <Input value={title} onChange={e => this.setState({ title: e.target.value })} />

                        <Divider style={{ marginTop: '30px' }}>2. Välj veckor som menyn ska gälla för</Divider>
                        <div style={{ marginBottom: '20px' }}>
                            { weeks.map(w => (
                                <Tag key={w} closable color="volcano" onClose={(e) => this.removeWeek(w)}>v{w}</Tag>
                            ))}
                        </div>

                        <DatePicker.WeekPicker 
                            value={null}
                            onChange={this.onWeekChange}
                            style={{ width: '100%' }}
                            placeholder="Välj veckor" 
                        />
                    </Row>
                </Modal>
            </Fragment>
        )
    };
}



// WEBPACK FOOTER //
// ./src/screens/dashboard/components/menu/CreateMenu.js